import { useState, useEffect, useContext } from 'react';
import './style.css';
import { Link } from 'react-router-dom';
import GlobalSVG from '../../utils/GlobalSVG';
import { AppContext } from "../../utils/ContextProvider";


const AccordionItem = (props) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [searched, setSearched] = useState(false)
  const [clientAlerts, setClientAlerts] = useState(false)
  const [filtered, setFiltered] = useState([])
  const alertDict = { 1: '#d7aaaa', 2: '#fde7a8' }
  const alertDictBell = { 0: '#0538A0', 1: '#F9941E', 2: '#F75D5F' }
  const context = useContext(AppContext);

  useEffect(() => {
    const alerts = props.content.reduce((arr, e) => {
      if (e.alerts) arr.push(...e.alerts);
      return arr
    }, []).map(e => e.severity)
    if (alerts.length) setClientAlerts(Math.max(...alerts))
    
    if (props.title.toLowerCase().includes(props.search)) {
      setSearched(true)
      setFiltered([])
      return
    }
    const tempFiltered = props.content.reduce((result, e, index) => {
      if (props.search === "" || e.building.toLowerCase().includes(props.search)) {
        result.push(index);
      }
      return result;
    }, []);

    setFiltered(tempFiltered)
    if (tempFiltered.length > 0) setSearched(true)
    else setSearched(false)
  }, [props])

  const handleToggle = () => {
    setIsExpanded(!isExpanded);
  };

  const handleClick = (index) => {
    props.onSelect(index)
  }

  return (
    <div className={`accordion-item`} onClick={() => handleClick(props.index)}>
      {searched && <div className={`flex flex-row flex-nowrap items-center justify-start cursor-pointer px-2`} onClick={handleToggle}>
        {!props.compact && GlobalSVG.pointMapBlack()}
        <button className="accordion-title text-left py-4 ml-4 w-10/12 tablet:text-sm mobile:text-xs">
          {props.title}
        </button>
        {clientAlerts !== false && context.getUserInfo.view_alerts &&
          <div>
            {GlobalSVG.ringer(alertDictBell[clientAlerts], '16px', '16px')}
          </div>
        }
        <svg className={`ml-2`} transform={`${isExpanded ? 'rotate(90)' : 'rotate(-90)'}`} width="8" height="16" viewBox="0 0 13 22" fill="#000000" xmlns="http://www.w3.org/2000/svg">
          <path d="M11.9683 1.30177C11.7987 1.13182 11.5972 0.996979 11.3754 0.90498C11.1536 0.81298 10.9159 0.765625 10.6758 0.765625C10.4357 0.765625 10.1979 0.81298 9.97613 0.90498C9.75435 0.996979 9.55288 1.13182 9.38328 1.30177L0.968277 9.71677C0.79832 9.88638 0.663483 10.0878 0.571484 10.3096C0.479484 10.5314 0.432129 10.7692 0.432129 11.0093C0.432129 11.2494 0.479484 11.4871 0.571484 11.7089C0.663483 11.9307 0.79832 12.1322 0.968277 12.3018L9.38328 20.7168C9.55301 20.8865 9.75451 21.0211 9.97628 21.113C10.198 21.2049 10.4357 21.2521 10.6758 21.2521C10.9158 21.2521 11.1535 21.2049 11.3753 21.113C11.597 21.0211 11.7985 20.8865 11.9683 20.7168C12.138 20.547 12.2726 20.3455 12.3645 20.1238C12.4564 19.902 12.5036 19.6643 12.5036 19.4243C12.5036 19.1842 12.4564 18.9465 12.3645 18.7248C12.2726 18.503 12.138 18.3015 11.9683 18.1318L4.85494 11.0001L11.9683 3.88677C12.6833 3.17177 12.6649 1.99844 11.9683 1.30177Z" fill="#000000" />
        </svg>
      </div>}
      {props.content.map((e, ix) => (
        (isExpanded && searched && (filtered.includes(ix) || filtered.length === 0)) &&
        <div className='flex flex-nowrap items-center justify-between'>
          <Link key={ix + "buildingid"} to={e.bills_only ? `/billreports?building=${e.building_id}` : `/${props.linkTo}?building=${e.building_id}`}>
            <div className='flex flex-nowrap items-center justify-between'>
              <div className='p-2 px-8' style={{ backgroundColor: `${e.alerts?.find(a => a.priority === 1 && !a.read_at) ? alertDict[1] : e.alerts?.find(a => a.priority === 2 && !a.read_at) ? alertDict[2] : '#ffffff'}` }}>
                <p className='text-xs'>
                  <strong>{e.building}</strong>
                </p>
                <p className='text-xs'>{e.address}, {e.city} - {e.province}</p>
              </div>
            </div>
          </Link>
          {!props.compact && context.getUserInfo.view_alerts &&
            <div className={`${e.alerts.length > 0 ? 'cursor-pointer' : ''} alerts-list`} onClick={() => props.setShowAlertDetails ? props.setShowAlertDetails(e.alerts) : null}>
              {GlobalSVG.ringer(e.alerts.length > 0 ? alertDictBell[Math.max(...e.alerts.map(e => e.severity))] : '#B8BBB9', '20px', '20px')}
            </div>
          }
        </div>
      ))
      }
    </div>
  );
};

const Accordion = (props) => {

  const [search, setSearch] = useState("")
  const [clients, setClients] = useState(null)
  const context = useContext(AppContext);

  useEffect(() => {
    if (!context.getUserInfo) return
    let buildings = context.getUserInfo.buildings
    let tempClients = {}
    for (let item of buildings) {
      tempClients[item.client_name] = tempClients[item.client_name] || []
      tempClients[item.client_name].push(item)
    }
    tempClients = Object.keys(tempClients).map(e => ({ title: e, content: tempClients[e] }))
    tempClients.sort(function (a, b) {
      var titleA = a.title.toUpperCase();
      var titleB = b.title.toUpperCase();
      if (titleA < titleB) {
        return -1;
      }
      if (titleA > titleB) {
        return 1;
      }
      return 0;
    });

    setClients(tempClients)
  }, [context.getUserInfo])


  const handleSearch = (e) => {
    setSearch(e.currentTarget.value.trim().toLowerCase())
  }

  return (
    <div className="accordion flex flex-col h-full">
      {!props.compact && <h2 className='text-bold desktop:text-3xl tablet:text-xl'>Companies</h2>}
      {!props.compact && <div className='flex flex-row items-center flex-nowrap w-full my-2 pr-3 rounded input-border'>
        <input className='border-none h-full tablet:p-3 mobile:p-1 flex-1 outline-none' type="text" onChange={handleSearch} placeholder='Search' />
        {GlobalSVG.searchSmall()}
      </div>}
      <div className='overflow-y-auto w-full h-full '>
        {clients && clients.map((item, index) => (
          <AccordionItem compact={props.compact} key={index} title={item.title} content={item.content} index={index} onSelect={props.onSelect} linkTo={props.linkTo ? props.linkTo : 'home'} search={search} setShowAlertDetails={props.setShowAlertDetails} />
        ))}
      </div>
    </div>
  );
};

export default Accordion;
